import { useTheme } from '../contexts/ThemeContext';
import { useAppSelector } from '../services/store';

interface HeaderProps {
  title: string;
}

export const Header = ({ title }: HeaderProps) => {
  const { theme, toggleTheme } = useTheme();
  const userReducer = useAppSelector(state => state.userReducer);
  const initial = userReducer?.profile?.name?.charAt(0) || 'م';

  return (
    <header className="dashHeader">
      <div className="dashHeaderRight">
        <h1 className="dashHeaderTitle">{title}</h1>
      </div>
      <div className="dashHeaderLeft">
        <button
          className="themeToggle"
          onClick={toggleTheme}
          title={theme === 'light' ? 'حالت شب' : 'حالت روز'}
          aria-label="تغییر تم"
        >
          {theme === 'light' ? '🌙' : '☀️'}
        </button>
        <div className="headerUserInfo">
          <div className="headerUserAvatar">{initial}</div>
          <div className="headerUserMeta">
            <span className="headerUserName">{userReducer?.profile?.name || 'مدیر'}</span>
            <span className="headerUserRole">ادمین</span>
          </div>
        </div>
      </div>
    </header>
  );
};
